import React from 'react'

function ConvertIcon(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#2A63FF" strokeWidth="1.6" {...props}>
      <path d="M6 16H22C22.2652 16 22.5196 15.8946 22.7071 15.7071C22.8946 15.5196 23 15.2652 23 15V2C23 1.73478 22.8946 1.48043 22.7071 1.29289C22.5196 1.10536 22.2652 1 22 1H8C7.73478 1 7.48043 1.10536 7.29289 1.29289C7.10536 1.48043 7 1.73478 7 2V3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 13L6 16L9 19" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 8H2C1.73478 8 1.48043 8.10536 1.29289 8.29289C1.10536 8.48043 1 8.73478 1 9V22C1 22.2652 1.10536 22.5196 1.29289 22.7071C1.48043 22.8946 1.73478 23 2 23H16C16.2652 23 16.5196 22.8946 16.7071 22.7071C16.8946 22.5196 17 22.2652 17 22V21" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 11L18 8L15 5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ConvertIcon
